<ng-template #walletModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="wallet-modal-title">
      <i class="fa fa-credit-card"></i>
      Minha carteira
    </h4>
    <button type="button" class="btn-close" aria-label="Fechar" (click)="modal.dismiss()"
      data-testid="wallet-modal-close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="wallet-tabs" role="tablist">
      <button type="button" class="wallet-tab" role="tab" [class.active]="isNationalSelected"
        [attr.aria-selected]="isNationalSelected" (click)="selectNational()" data-testid="wallet-tab-national">
        Brasil (R$)
      </button>
      <button type="button" class="wallet-tab" role="tab" [class.active]="!isNationalSelected"
        [attr.aria-selected]="!isNationalSelected" (click)="selectInternational()"
        data-testid="wallet-tab-international">
        Internacional (US$)
      </button>
    </div>

    <ng-container *ngIf="isNationalSelected">
      <div class="wallet-state" *ngIf="loading" data-testid="wallet-loading">
        <i class="fa fa-spinner fa-spin fa-2x"></i>
        <p>Consultando sua carteira...</p>
      </div>

      <!-- 403 wallet_disabled: nenhuma flag de cobrança ligada. Não é erro. -->
      <div class="wallet-state muted" *ngIf="!loading && isDisabled" data-testid="wallet-disabled">
        <i class="fa fa-lock fa-2x"></i>
        <p class="title">Carteira não habilitada para esta conta</p>
        <p class="detail">
          Sua conta ainda é cobrada pelo saldo tradicional. Quando a carteira em R$ for habilitada, o
          saldo aparece aqui.
        </p>
      </div>

      <!-- 503 wallet_unavailable: estado previsto, com retentativa prevista. -->
      <div class="wallet-state warning" *ngIf="!loading && isUnavailable" data-testid="wallet-unavailable">
        <i class="fa fa-exclamation-triangle fa-2x"></i>
        <p class="title">Não foi possível consultar agora</p>
        <p class="detail">{{ retryAfterLabel || error.message }}</p>
        <button type="button" class="sf-btn sf-btn--primary sf-btn--sm" (click)="loadBalance()"
          data-testid="wallet-retry">
          <i class="fa fa-refresh"></i>
          Tentar de novo
        </button>
      </div>

      <div class="wallet-state warning" *ngIf="!loading && hasUnknownError" data-testid="wallet-error">
        <i class="fa fa-exclamation-circle fa-2x"></i>
        <p class="title">Não foi possível consultar agora</p>
        <p class="detail">{{ error.message }}</p>
        <button type="button" class="sf-btn sf-btn--primary sf-btn--sm" (click)="loadBalance()">
          <i class="fa fa-refresh"></i>
          Tentar de novo
        </button>
      </div>

      <!-- Card em 2 casas, extrato mantém a fração de centavo (ver o docblock do
           `MoneyMicrosPipe`). O `title` guarda o valor cheio. -->
      <div class="wallet-amounts" *ngIf="!loading && balance" data-testid="wallet-amounts">
        <div class="wallet-amount featured">
          <span class="label">Disponível</span>
          <strong data-testid="wallet-available" [title]="balance.available_micros | moneyMicros : balance.currency">
            {{ balance.available_micros | moneyMicros : balance.currency : balanceLocale : balanceFractionDigits }}
          </strong>
        </div>

        <div class="wallet-amount">
          <span class="label">Saldo</span>
          <strong data-testid="wallet-balance" [title]="balance.balance_micros | moneyMicros : balance.currency">
            {{ balance.balance_micros | moneyMicros : balance.currency : balanceLocale : balanceFractionDigits }}
          </strong>
        </div>

        <div class="wallet-amount">
          <span class="label">Reservado</span>
          <strong data-testid="wallet-held" [title]="balance.held_micros | moneyMicros : balance.currency">
            {{ balance.held_micros | moneyMicros : balance.currency : balanceLocale : balanceFractionDigits }}
          </strong>
        </div>

        <p class="overdraft" *ngIf="balance.overdraft" data-testid="wallet-overdraft">
          <i class="fa fa-exclamation-triangle"></i>
          Sua carteira está negativa. Recarregue para continuar enviando.
        </p>
      </div>
    </ng-container>

    <!-- Estado vazio explícito, nunca zero: carteira em dólar só existe na F4. -->
    <div class="wallet-state muted" *ngIf="!isNationalSelected" data-testid="wallet-international-empty">
      <i class="fa fa-globe fa-2x"></i>
      <p class="title">Carteira internacional ainda não disponível</p>
      <p class="detail">
        A carteira opera hoje apenas em reais. Nada de saldo em dólar foi calculado ainda — por isso
        esta aba não mostra valor nenhum, e não zero.
      </p>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="sf-btn sf-btn--secondary" (click)="modal.dismiss()">Fechar</button>
    <a class="sf-btn sf-btn--primary" routerLink="/wallet" (click)="modal.close()"
      data-testid="wallet-statement-link">
      Ver extrato completo
      <i class="fa fa-arrow-right"></i>
    </a>
  </div>
</ng-template>
